import { AuthProvider, useAuth } from './auth/AuthProvider'
import { MapView } from './routes/MapView'
import { SignIn } from './routes/SignIn'

/**
 * Root shell: branches on JWT presence. Signed-out → SignIn. Signed-in → MapView.
 *
 * The `<AuthProvider>` is mounted here so that both the `/` index route and
 * nested routes (when they exist) can read/write the JWT from a single source.
 * `localStorage['clearroute:jwt']` remains the persistence layer.
 */
export function App() {
  return (
    <AuthProvider>
      <AppBody />
    </AuthProvider>
  )
}

function AppBody() {
  const { jwt } = useAuth()
  return jwt ? <MapView /> : <SignIn />
}
